import React, { Fragment } from 'react';
import { Item, Grid, Card, Divider, List } from 'semantic-ui-react';

import InformationItem from '../../../InformationItem';
import { dateFormat, dateTimeFormat } from '../../../../utils/dateFormat';

const Litigation = ({
  nebSentDate,
  courtName,
  courtAddress,
  lawyer,
  conciliationAt,
  nRg,
  courtHearingAt,
  courtDecisionDate,
  crmState,
  airlineAgreementAmount,
  airlineAgreementDate,
  paxAgreementAmount,
  settlementType,
  legalFees,
  refundFromLawyerDate,
  refundFromLawyerAmountForPax,
  refundFromLawyerLegalFeesAmount,
  paxTransferDate,
  paxToTransferAmount
}) => {
  const common_condition =
    crmState === 'c4_court_date_fixed' ||
    crmState === 'c4_post_court_application_negociation' ||
    crmState === 'c4_pending_court_decision' ||
    /^c[5-9]/.test(crmState);
  const lawyer_content = lawyer && `${lawyer.name} ${lawyer.surname}`;

  const airline_agreement_date =
    airlineAgreementDate !== null && crmState.startsWith('c6');
  const legal_fees = legalFees !== null && crmState.startsWith('c6');
  const pax_agreement_amount =
    paxAgreementAmount !== null && crmState.startsWith('c6');

  const refund_from_lawyer_date =
    refundFromLawyerDate !== null && /^c[7-9]/.test(crmState);
  const refund_from_lawyer_legal_fees_amount =
    refundFromLawyerLegalFeesAmount !== null && /^c[7-9]/.test(crmState);
  const refund_from_lawyer_amount_for_pax =
    refundFromLawyerAmountForPax !== null && /^c[7-9]/.test(crmState);

  const airline_agreement_amount =
    airlineAgreementAmount !== null && /^c[6-9]/.test(crmState);

  return (
    <Fragment>
      <Divider />
      <Item>
        <Item.Content>
          <Item.Header>Litigation</Item.Header>
          <Divider hidden />
          <Card fluid>
            <Card.Content>
              <Grid>
                <Grid.Row columns={2} divided>
                  <Grid.Column>
                    <List>
                      {!crmState.startsWith(
                        'c0_national_enforcement_body'
                      ) && (
                        <InformationItem
                          icon='university'
                          content={courtName}
                          info='Competetent Court Name'
                        />
                      )}
                      {!crmState.startsWith(
                        'c0_national_enforcement_body'
                      ) && (
                        <InformationItem
                          icon='university'
                          content={courtAddress}
                          info='Competetent Court Address'
                        />
                      )}
                      <InformationItem
                        icon='law'
                        content={lawyer_content}
                        info='Lawyer'
                      />
                      {common_condition && (
                        <InformationItem
                          icon='calendar outline'
                          content={dateTimeFormat(courtHearingAt)}
                          info='New Court Hearing Info'
                        />
                      )}
                      {(crmState === 'c4_pending_court_decision' ||
                        /^c[6-9]/.test(crmState)) && (
                        <InformationItem
                          icon='calendar outline'
                          content={dateFormat(courtDecisionDate)}
                          info='Court Decision Date'
                        />
                      )}
                      {common_condition && (
                        <InformationItem
                          icon='calendar outline'
                          content={dateTimeFormat(conciliationAt)}
                          info='Conciliation Date'
                        />
                      )}
                      {common_condition && (
                        <InformationItem
                          icon='briefcase'
                          content={nRg}
                          info='n° RG'
                        />
                      )}
                    </List>
                  </Grid.Column>
                  <Grid.Column>
                    <List>
                      {(airline_agreement_date || refund_from_lawyer_date) && (
                        <InformationItem
                          icon='calendar outline'
                          content={
                            refund_from_lawyer_date
                              ? dateFormat(refundFromLawyerDate)
                              : dateFormat(airlineAgreementDate)
                          }
                          info={
                            refund_from_lawyer_date
                              ? 'Refund From Lawyer Date'
                              : 'Agreement Date'
                          }
                        />
                      )}
                      {airline_agreement_amount && (
                        <InformationItem
                          icon='money'
                          content={airlineAgreementAmount}
                          info='Agreement Airline Amount'
                        />
                      )}
                      {(refund_from_lawyer_legal_fees_amount || legal_fees) && (
                        <InformationItem
                          icon='balance'
                          content={
                            refund_from_lawyer_legal_fees_amount
                              ? refundFromLawyerLegalFeesAmount
                              : legalFees
                          }
                          info={
                            refund_from_lawyer_legal_fees_amount
                              ? 'Refund From Lawyer Legal Fees Amount'
                              : 'Legal Fees'
                          }
                        />
                      )}
                      {(pax_agreement_amount || refund_from_lawyer_amount_for_pax) && (
                        <InformationItem
                          icon='user'
                          content={
                            refund_from_lawyer_amount_for_pax
                              ? refundFromLawyerAmountForPax
                              : paxAgreementAmount
                          }
                          info={
                            refund_from_lawyer_amount_for_pax
                              ? 'Refund From Lawyer Amount For Pax'
                              : 'Pax Amount'
                          }
                        />
                      )}
                      {/^c[689]/.test(crmState) && (
                        <InformationItem
                          icon='file'
                          content={settlementType}
                          info='Settlement Type'
                        />
                      )}
                      {crmState === 'c7_pax_to_refund' && (
                        <InformationItem
                          icon='money'
                          content={paxToTransferAmount}
                          info='Pax To Transfer Amount'
                        />
                      )}
                      {crmState === 'c7_pax_to_refund' && (
                        <InformationItem
                          icon='calendar outline'
                          content={dateFormat(paxTransferDate)}
                          info='Pax Transfer Date'
                        />
                      )}
                      {crmState === 'c0_national_enforcement_body_sent' && (
                        <InformationItem
                          icon='calendar outline'
                          content={dateFormat(nebSentDate)}
                          info='NEB Sent Date'
                        />
                      )}
                    </List>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Card.Content>
          </Card>
        </Item.Content>
      </Item>
    </Fragment>
  );
};

export default Litigation;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/Litigation/index.js